document.addEventListener( 'lazybeforeunveil', ( event ) => {
    const { target } = event;
    const bg = target.getAttribute( 'data-bg' );

    if ( bg ) {
        const src = target.getAttribute( 'data-src' ) || target.src;

        if ( bg === 'parent' ) {
            target.setAttribute( 'hidden', true );
            target.parentNode.style.backgroundImage = `url(${ src })`;
        } else {
            const arr = bg.split( ',' );
            let bgi = '';

            // multiple backgrounds
            arr.forEach( ( el, i ) => {
                if ( i > 0 ) {
                    bgi += ',';
                }
                bgi += `url(${ el.trim() })`;
            } );

            target.style.backgroundImage = bgi;
        }
    }
});